var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bbcd"},[_c('el-card',{staticStyle:{"padding-top":"40px"}},[_c('div',{staticClass:"d2",on:{"click":function($event){return _vm.go('./bbhome')}}},[_vm._v(" 车辆报表 ")]),_c('div',{staticClass:"d2",on:{"click":function($event){return _vm.go('./jzmx')}}},[_vm._v(" 加注明细 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }